module.exports = __webpack_public_path__ + "icon_alert_50red.eb9e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_alert_50red.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_alert_50red.svg
// module chunks = main